import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import {
  isRccUrlPatternInIntegratedExecutionMode,
  isRccUrlPatternInStandaloneExecutionMode
} from './rcc-redirect.utils';
import { canActivateRccUrlRedirectGuard } from './rcc-url-redirect.guard';

const routes: Routes = [
  {
    matcher: isRccUrlPatternInStandaloneExecutionMode,
    canActivate: [canActivateRccUrlRedirectGuard],
    children: []
  },
  {
    matcher: isRccUrlPatternInIntegratedExecutionMode,
    canActivate: [canActivateRccUrlRedirectGuard],
    children: []
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RccRedirectModule {}
